import React from "react";
import { t } from "i18next";
import { SVGICONS } from "config";
import useUpdateUserProfile from "service-hooks/useUpdateUserProfile";
import TextInput from "components/TextInput";
import { CustomButton } from "components/Button";
import PhoneNumberInput from "components/phone-number-input";
import { SlideInFooter } from "components/layouts/SlideInLayout";

const fields = [
  {
    label: t("Phone Number"),
    name: "phoneNumber",
    placeHolder: "XXX-XXX-XXXX",
    readOnly: false,
    type: "tel",
  },
  {
    label: t("Your Name"),
    name: "name",
    placeHolder: t("Your Name"),
    readOnly: false,
    type: "text",
    allowChange: true,
  },
  {
    label: t("Email Address"),
    name: "email",
    placeHolder: t("Email Address"),
    readOnly: false,
    type: "email",
    icon: <SVGICONS.EmailIcon />,
  },
];

const UserProfileForm = ({
  isPage = false,
  setUserInfoModal = () => {},
  isOpenUserInfoModal = false,
}) => {
  const {
    formstate,
    initialValues: userData,
    onFinish,
    updateFormState,
  } = useUpdateUserProfile({
    setUserInfoModal,
    isOpenUserInfoModal,
  });

  const { values, errors } = formstate;
  const { loading: isLoading, error } = values;

  const stopClickPropagation = (e) => e.stopPropagation();

  const renderButton = () => {
    // const isLoading = formstate?.values?.loading;
    const buttonText = isLoading ? t("Loading") : t("Submit");
    return (
      <CustomButton
        type="submit"
        onClick={isLoading ? stopClickPropagation : onFinish}
        disabled={isLoading}
        className="cursor-pointer block text-center py-3 rounded text-brand-text-primary bg-brand-base-primary text-16x w-full"
      >
        <span className="font-bold text-center">{buttonText}</span>
      </CustomButton>
    );
  };

  return (
    <>
      <div className="p-5 flex flex-col gap-2">
        {fields.map((field) => (
          <div key={field.name} className="pb-2">
            {field.type === "tel" ? (
              <PhoneNumberInput
                value={values?.[field?.name]}
                handleChange={(e) => {
                  updateFormState(field?.name, e);
                }}
                error={errors?.[field?.name]}
                disabled={field?.allowChange ? false : userData?.[field?.name]?.length > 0}
                readOnly={field?.allowChange ? false :userData?.[field?.name]?.length > 0}
                mandatory={!userData?.[field?.name]?.length > 0}
                placeHolder={field.placeHolder}
              />
            ) : (
              <TextInput
                label={field.label}
                value={values?.[field?.name]}
                onChange={(e) => updateFormState(field?.name, e.target.value)}
                name={field?.name}
                icon={field?.icon}
                error={errors[field.name]}
                type={field.type}
                placeHolder={field.placeHolder}
                disabled={field?.allowChange ? false : userData?.[field?.name]?.length > 0}
                readOnly={field?.allowChange ? false :userData?.[field?.name]?.length > 0}
                labelClasses="text-14x text-black"
                mandatory={!userData?.[field?.name]?.length > 0}
              />
            )}
          </div>
        ))}

        {error && <div className="text-red-500 text-center">{error}</div>}
      </div>
      {!isPage ? (
        <div className="p-5 flex flex-col gap-2">
        {renderButton()}
        </div>
      ) : (
        <SlideInFooter>{renderButton()}</SlideInFooter>
      )}
    </>
  );
};

export default UserProfileForm;
